module.exports = __webpack_public_path__ + "img/guide_mobile.0ca82164.jpg";